import { render, staticRenderFns } from "./auto-computed-modal.vue?vue&type=template&id=965b59f8&scoped=true"
import script from "./auto-computed-modal.vue?vue&type=script&lang=js"
export * from "./auto-computed-modal.vue?vue&type=script&lang=js"
import style0 from "./auto-computed-modal.vue?vue&type=style&index=0&id=965b59f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965b59f8",
  null
  
)

export default component.exports